/**
 * TestcaseResults component is responsible for displaying the details of
 * test cases for a student's programming submission. It uses the access control
 * variables to determine whether the test cases should be shown to the student
 * */

import React from "react";
import Testcase from "../Testcase/Testcase";
import "./testcase_details_student.styles.scss";
import { Alert } from "react-bootstrap";
import log from "loglevel";

export default function TestcaseResults({
  access,
  testResults,
  testcasesExportHandler,
}) {

  log.debug("TestcaseResults.jsx props: ", testResults);

  const countPassedTestcases = () => {
    let count = 0;
    testResults?.forEach((testcase) => {
      if (testcase.passed) {
        count++;
      }
    });
    return count;
  }

  return (
    //show Testcase details component by following access control
    <div>
      {/* show an alert for passed test cases */}
      {testResults && testResults.length > 0 && (
        <Alert variant="info">
          {`You have passed ${countPassedTestcases()} out of ${testResults.length} test cases.`}
        </Alert>
      )}
      {access?.enable_display_visible_testcases ||
        access?.enable_display_hidden_testcases ? (
        <>
          {testResults?.length > 0 ? (
            <Testcase
              testResults={testResults}
              testcasesExportHandler={testcasesExportHandler}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
